/* eslint-disable react-hooks/exhaustive-deps */
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useState, useCallback } from "react";
import toast from "react-hot-toast";
import { PrimaryButton, SecondaryButton } from "../../StyledCss/styledbtn";
import LoadingView from "../LoadingView";
import FailureView from "../FailureView";
import PageHeader from "../PageHeader";
import { PageHeaderName } from "../../StyledCss/styledComponents";
import Header from "../Header";
import { useNavigate } from "react-router-dom";
import LeftNavBar from "../LeftNavBar";
import "./index.css";
import { ErrorText } from "../../StyledCss/styledComponents";
import {
  getClients,
  addClient,
  deleteClient,updateClient 
} from "../../api/services/hroneApi";
import { convertKeysToCamelCase } from "../../util/convertCamelCase";
import { convertKeysToSnakeCase } from "../../util/convertToSnakeCase";
import { BsFillTrashFill } from "react-icons/bs";
import { RiPencilLine } from "react-icons/ri";
import { useMemo } from "react";
import SlidingModal from "../SlidingModal/slidingModal";
import AddClientPopup from "../AddClient";
import PopupModal from "../PopupModal";
import { Eye } from "lucide-react";
import { usePermissions } from "../../redux/slices/permissionsSlice";
import { FEATURE_CODES } from "../../util/featureCodes";
const apiStatusConstants = {
  initial: "INITIAL",
  success: "SUCCESS",
  failure: "FAILURE",
  inProgress: "IN_PROGRESS",
};

const Clients = () => {
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();
  const canCreateClient = hasPermission(FEATURE_CODES.CLIENT_CREATE);
  const canEditClient = hasPermission(FEATURE_CODES.CLIENT_EDIT);
  const canDeleteClient = hasPermission(FEATURE_CODES.CLIENT_DELETE);
  const canViewProjects = hasPermission(FEATURE_CODES.PROJECT_VIEW);
  const [apiStatus, setApiStatus] = useState(apiStatusConstants.initial);
  const [clientsData, setClientsData] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingClient, setEditingClient] = useState(null);
  const [clientToDelete, setClientToDelete] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const [loadingStates, setLoadingStates] = useState({
    addClient: false,
    updateClient: false,
    deleteClient: false,
  });
  const [errorMessages, setErrorMessages] = useState({
      addClient: "",
      updateClient: "",
      deleteClient: "",
    });

  const setLoading = (operation, isLoading) => {
    setLoadingStates((prev) => ({ ...prev, [operation]: isLoading }));
  };

  const getClientsList = useCallback(async () => {
    try {
      setApiStatus(apiStatusConstants.inProgress);
      const response = await getClients();

      if (response.ok) {
        const data = convertKeysToCamelCase(await response.json());
        setClientsData(data);
        setApiStatus(apiStatusConstants.success);
      } else {
        setApiStatus(apiStatusConstants.failure);
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
      setApiStatus(apiStatusConstants.failure);
    }
  }, []);
  useEffect(() => {
    getClientsList();
  }, [getClientsList]);
  const addNewClient = useCallback(
    async (newClient) => {
      try {
        setLoading("addClient", true);

        const response = await addClient(convertKeysToSnakeCase(newClient));
        if (response.ok) {
          toast.success("Client Added Successfully");
          await getClientsList();
          setIsPopupOpen(false);
        } else {
          const data=await response.json();
          setErrorMessages(prev => ({...prev, addClient: data.detail}));
        }
      } catch (error) {
        toast.error("Client Cannot be Added");
        console.error("Error adding Client:", error);
      } finally {
        setLoading("addClient", false);
      }
    },
    [getClientsList],
  );

  const confirmDeleteClient = useCallback(async () => {
    try {
      setLoading("deleteClient", true);

      const response = await deleteClient(clientToDelete.id);
      if (response.status === 200) {
        toast.success("Client Deleted Successfully");
        await getClientsList();
        setIsDeleteModalOpen(false);
        setClientToDelete(null);
      } else {
          const data=await response.json();
          setErrorMessages(prev => ({...prev, deleteClient: data.detail}));
      }
    } catch (error) {
      console.error("Error deleting client:", error);
      toast.error("Failed to delete client");
    } finally {
      setLoading("deleteClient", false);
    }
  }, [clientToDelete, getClientsList]);
   const handleUpdateClient = useCallback(
      async (updatedClient) => {
        try {
          setLoading("updateClient", true);
  
          const response = await updateClient(convertKeysToSnakeCase(updatedClient));
          if (response.ok) {
            toast.success("Client Updated Successfully");
            await getClientsList();
            setIsPopupOpen(false);
            setIsEditMode(false);
            setEditingClient(null);
          } else {
          const data=await response.json();
          setErrorMessages(prev => ({...prev, updateClient: data.detail}));          }
        } catch (error) {
          toast.error("Failed to update client");
  
          console.error("Error updating client:", error);
        } finally {
          setLoading("updateClient", false);
        }
      },
      [getClientsList],
    );
  const handleAddClient = () => {
    setErrorMessages(prev => ({...prev, addClient: "", updateClient: ""}));
    setIsPopupOpen(true);
  };
  const onClickRetry = () => {
    getClientsList();
  };

    const editClient = useCallback((client) => {
      setEditingClient(client);
      setIsEditMode(true);
      setErrorMessages(prev => ({...prev, addClient: "", updateClient: ""}));
      setIsPopupOpen(true);
    }, []);

  const handleDeleteClient = useCallback((client) => {
    setClientToDelete(client);
    setIsDeleteModalOpen(true);
    setErrorMessages(prev => ({...prev, deleteClient: ""}));

  }, []);
    const handleViewProjects = useCallback((clientId) => {
      navigate(`/projects/${clientId}`)
  }, []);


  const toggleIsPopupOpen = useCallback(() => {
    setIsPopupOpen(false);
    setIsEditMode(false);
    setEditingClient(null);
    setErrorMessages(prev => ({...prev, addClient: "", updateClient: ""}));
  }, []);
  const cancelDeleteClient = useCallback(() => {
    setIsDeleteModalOpen(false);
    setClientToDelete(null);
    setErrorMessages(prev => ({...prev, deleteClient: ""}));


  }, []);
  const defaultColDef = useMemo(
    () => ({
      cellStyle: { fontSize: "14px" },
      sortable: true,
      filter: true,
      floatingFilter: true,
    }),
    [],
  );
  const columnDefs = useMemo(
    () => [
      {
        headerName: "CLIENT NAME",
        field: "name",
        width: 300,
        pinned: "left",
        suppressMenu: true
      },
       {
        headerName: "CLIENT EMAIL",
        field: "clientEmail",
        width: 400,
        suppressMenu: true
      },
      {
        headerName: "ADDRESS",
        field: "address",
        width: 300,
        suppressMenu: true
      },
      {
        headerName: "STATE",
        field: "state",
        width: 250,
        suppressMenu: true
      },
      {
        headerName: "COUNTRY",
        field: "country",
        width: 200,
        suppressMenu: true
      },
      {
        headerName: "GST NUMBER",
        field: "gstNumber",
        width: 250,
        suppressMenu: true,
        cellRenderer: (params) => params.value || "-",
        cellStyle: { textAlign: "center" },
      },
      {
        headerName: "NO OF PROJECTS",
        field: "projectsCount",
        width: 200,
        suppressMenu: true,
      },
      {
        headerName: "ACTIONS",
        width: 120,
        cellRenderer: (params) => {
          return (
            <div
              style={{
                display: "flex",
                gap: "10px",
                alignItems: "center",
                height: "100%",
              }}
            >
              {canEditClient && (
                <div title="Edit" className="icon-wrapper">
                  <RiPencilLine
                    style={{
                      cursor: "pointer",
                      color: "#28a745",
                      fontSize: "20px",
                    }}
                    onClick={() => editClient(params.data)}
                    title="Edit"
                  />
                </div>
              )}

              {canDeleteClient && (
                <div title="Delete" className="icon-wrapper">
                  <BsFillTrashFill
                    style={{
                      cursor: "pointer",
                      color: "#dc3545",
                      fontSize: "20px",
                    }}
                    onClick={() => handleDeleteClient(params.data)}
                  />
                </div>
              )}
              <div
                title={
                  canViewProjects
                    ? "View Projects"
                    : "You don't have permission to view projects"
                }
                className="icon-wrapper"
              >
                <Eye
                  style={{
                    cursor: canViewProjects ? "pointer" : "not-allowed",
                    color: canViewProjects ? "#007bff" : "#cccccc",
                    fontSize: "20px",
                  }}
                  onClick={() =>
                    canViewProjects && handleViewProjects(params.data.id)
                  }
                />
              </div>
            </div>
          );
        },
        sortable: false,
        filter: false,
        floatingFilter: false,
      },
    ],
    [handleDeleteClient, editClient, handleViewProjects, canEditClient, canDeleteClient, canViewProjects],
  );
  const renderTable = useCallback(
    () => (
      <div
        className="ag-theme-alpine"
        style={{
          height: "78vh",
          fontSize: "14px",
          marginLeft: "20px",
          marginRight: "20px",
          fontFamily: "Arial, Helvetica, sans-serif",
          backgroundColor: "#FFFFFF",
        }}
      >
        <AgGridReact
          columnDefs={columnDefs}
          rowData={clientsData}
          pagination={true}
          paginationPageSize={10}
          defaultColDef={defaultColDef}
          rowSelection="multiple"
          suppressRowClickSelection={true}
          enableCellTextSelection={true}

        />
      </div>
    ),
    [columnDefs, clientsData, defaultColDef],
  );

  const renderData = () => {
    switch (apiStatus) {
      case apiStatusConstants.inProgress:
        return <LoadingView />;
      case apiStatusConstants.success:
        return renderTable();
      case apiStatusConstants.failure:
        return <FailureView onClickRetry={onClickRetry} />;
      default:
        return null;
    }
  };

  return (
    <div>
      <Header />
      <div className="d-flex">
        <LeftNavBar />
        <div className="page-content-wrapper">
          <PageHeader>
            <PageHeaderName>Clients</PageHeaderName>
            {canCreateClient && (
              <div className="extra-btn-div" style={{ marginRight: "18px" }}>
                <PrimaryButton onClick={handleAddClient} type="button">
                  Add Client
                </PrimaryButton>
              </div>
            )}
          </PageHeader>
          <div className="table-container">{renderData()}</div>
        </div>
      </div>

      {/* Add/Edit Project Modal */}
      <SlidingModal
        modalName={isEditMode ? "Edit Client" : "Add Client"}
        closeBtn={toggleIsPopupOpen}
        isModalOpen={isPopupOpen}
      >
        <AddClientPopup
          popupOpen={isPopupOpen}
          toggleIsPopupOpen={toggleIsPopupOpen}
          closeBtn={toggleIsPopupOpen}
          onSubmitData={isEditMode ? handleUpdateClient : addNewClient}
          defaultValues={isEditMode ? editingClient : null}
          isEditMode={isEditMode}
          isLoading={loadingStates.addClient || loadingStates.updateClient}
          errorMessage={errorMessages.updateClient || errorMessages.addClient}
        />
      </SlidingModal>
      {/* Delete Confirmation Modal */}
      <div className="no-modal-mb">
        <PopupModal
          showModal={isDeleteModalOpen}
          modalName="Confirm Delete"
          closeBtn={cancelDeleteClient}
          marginBottom="0px"
        >
          <div>
            <p>
              Are you sure you want to delete the client "{clientToDelete?.name}
              "?
            </p>
            {errorMessages.deleteClient && (
                            <ErrorText className="mt-3">*{errorMessages.deleteClient}</ErrorText>
                          )}
            <div
              style={{
                display: "flex",
                gap: "10px",
                justifyContent: "center",
                marginTop: "15px",
              }}
            >
              <SecondaryButton onClick={cancelDeleteClient}>No</SecondaryButton>
              <PrimaryButton
                onClick={confirmDeleteClient}
                disabled={loadingStates.deleteClient}
              >
                {loadingStates.deleteClient ? "Deleting..." : "Yes"}
              </PrimaryButton>
            </div>
          </div>
        </PopupModal>
      </div>
    </div>
  );
};

export default Clients;
